/**
 * Admin KYC Service
 * Handles all KYC-related admin API calls
 */

import { getApi, postApi, deleteApi } from '../adminApi';

/**
 * Get KYC statistics
 * @returns {Promise}
 */
export const getKYCStats = async () => {
  return getApi('kyc/stats');
};

/**
 * Get all KYC submissions with filters
 * @param {Object} params - Query parameters (page, limit, status, etc.)
 * @returns {Promise}
 */
export const getKYCList = async (params = {}) => {
  const queryParams = new URLSearchParams(params).toString();
  return getApi(`kyc?${queryParams}`);
};

/**
 * Get KYC details by ID
 * @param {string} kycId - KYC submission ID
 * @returns {Promise}
 */
export const getKYCDetails = async (kycId) => {
  return getApi(`kyc/${kycId}`);
};

/**
 * Process KYC submission
 * @param {string} kycId - KYC submission ID
 * @param {string} status - Status ('approved' | 'rejected')
 * @param {string} remarks - Optional remarks
 * @returns {Promise}
 */
export const processKYC = async (kycId, status, remarks = '') => {
  return postApi(`kyc/${kycId}/process`, {
    status,
    remarks: remarks.trim() || undefined
  });
};

/**
 * Delete KYC submission
 * @param {string} kycId - KYC submission ID
 * @returns {Promise}
 */
export const deleteKYC = async (kycId) => {
  return deleteApi(`kyc/${kycId}`);
};

